var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item)?_c('page-title',{attrs:{"title":_vm.item.title}}):_vm._e(),(_vm.item)?_c('b-row',[_c('b-col',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.contentBlock)}})])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }